import { useEffect, useState } from 'react';
// import MesLogo from '../../images/getsitelogo.png';
import LoretteLogo from '../../images/loretteLogo.png';
import LoretteLogoWhite from '../../images/loretteLogoWhite.png';
import useUserToken from '../../context/userTokenContext';
import useThemeStore from "../../context/themeContext";
import '../../components/themeController.css'
import useNavbarStore from '../../context/useNavbarStore';
import '../layout/navbarSearch.css'
import useNavbarSearchStore from '../../context/useNavBarSearchStore';
import useLocationsStore from '../../context/locationsStore';

function TopBar() {
    // Store States
    const setUserToken = useUserToken((state) => state.setUserToken);
    const { searchList, clearSearchList } = useNavbarSearchStore();
    const { clearLocations } = useLocationsStore();
    const { currentTheme, themeSwitchHandler } = useThemeStore();
    const { isOpen, toggleOffcanvas } = useNavbarStore();

    const toggleTheme = () => {
        const newTheme = currentTheme === "light" ? "dark" : "light";
        themeSwitchHandler(newTheme);
    };

    const logout = () => {
        setUserToken(null);
        clearSearchList();
        clearLocations();
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    function useMediaQuery(query) {
        const [matches, setMatches] = useState(false);

        useEffect(() => {
            const mediaQuery = window.matchMedia(query);

            // Set initial value
            setMatches(mediaQuery.matches);

            // Shared listener logic
            const handler = (event) => setMatches(event.matches);

            mediaQuery.addEventListener("change", handler);
            return () => mediaQuery.removeEventListener("change", handler);
        }, [query]);

        return matches;
    }

    const [searchTerm, setSearchTerm] = useState('');
    const [searchIsOpen, setSearchIsOpen] = useState(false); // Search dropdown visibility
    const [searchIsOpenMobile, setSearchIsOpenMobile] = useState(false); // Search dropdown visibility

    useEffect(() => {
        console.log(searchList)
    }, [searchList]);

    // Filter Data based on searchTerm
    const filteredData = searchList.filter(item =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleBlur = (target) => {
        target == "mobile" ? setTimeout(() => setSearchIsOpenMobile(false), 100) :
            setTimeout(() => setSearchIsOpen(false), 100);
    };

    // Search Value clicked
    const searchValueClicked = (e, item) => {
        console.log(item);
        window.location.href = `/gateways/${item.id}/${item.server}`;
    };

    const isLargeScreen = useMediaQuery("(min-width: 1024px)");

    return (
        <div className="navbar bg-gradient-to-l from-[var(--gradientFirst)] to-[var(--gradientSecond)] mt-4 px-2 lg:px-8 w-[98%] self-center rounded-full">
            <div className="navbar-start">
                <div className="dropdown">
                    <div onClick={toggleOffcanvas} role="button" className="btn btn-ghost btn-circle">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M4 6h16M4 12h16M4 18h7" />
                        </svg>
                    </div>
                    {/* <ul
                        tabIndex={0}
                        className="menu menu-sm dropdown-content bg-[var(--gradientSecond)] rounded-box z-[1] mt-3 w-52 p-2 shadow">
                        <li><a>Dashboard</a></li>
                        <li><a>Portfolio</a></li>
                        <li><a>About</a></li>
                    </ul> */}
                </div>
            </div>
            <div className="navbar-center">
                {/* <a href="/" className="btn btn-ghost text-xl text-[var(----textPrimary)]">Network Monitoring System</a> */}
            </div>
            <div className="navbar-end gap-4">
                {/* <input type="text" placeholder="Type here" className="input w-full max-w-xs bg-[var(--gradientFirst)]" />
                <button className="btn btn-ghost btn-circle">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                </button> */}

                {/* Web Search */}
                {isLargeScreen && (
                    <div className="input-wrapper">
                        <button className="icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                        </button>
                        <input
                            type="text"
                            name="text"
                            className="input"
                            style={{ color: "var(--textPrimary)" }}
                            placeholder="Search Gateway..."
                            autoComplete="off"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onFocus={() => setSearchIsOpen(true)}
                            onBlur={() => handleBlur('web')}
                        />
                        {searchIsOpen && searchTerm && filteredData.length > 0 && (
                            <div className="dropdown absolute top-full left-0 right-0 max-h-[300px] overflow-y-auto bg-white border border-gray-300 rounded z-[9999]">
                                {filteredData.map((item, index) => (
                                    <div
                                        key={index}
                                        className="dropdown-item hover:bg-gray-300"
                                        onMouseDown={(e) => searchValueClicked(e, item)}
                                        style={{ padding: "8px", cursor: "pointer" }}
                                    >
                                        {item.name}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}

                {/* Mobile Search */}
                {!isLargeScreen && (<details className="dropdown">
                    <summary className="btn m-1 btn-circle bg-[var(--gradientFirst)] hover:bg-gray-300 shadow-[0px_0px_3px_rgba(21,87,192)] border-none" onClick={() => setSearchIsOpen(true)}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                    </summary>
                    <ul className="menu dropdown-content bg-[var(--gradientSecond)] z-[1] w-52 p-2 shadow">

                        <input type="text" name="text" className="bg-[var(--gradientSecond)] focus:outline-none text-[var(--textPrimary)]"
                            placeholder="Search Gateway..."
                            autoComplete="off"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onFocus={() => setSearchIsOpenMobile(true)}
                            onBlur={() => handleBlur('mobile')} />

                        {searchIsOpenMobile && filteredData.length > 0 && (
                            <li className="dropdown absolute top-full left-0 right-0 max-h-[300px] overflow-y-auto bg-white border border-gray-300 rounded z-[9999] overflow-x-hidden">
                                {filteredData.map((item, index) => (

                                    <div key={index} className="dropdown-item hover:bg-gray-300" onMouseDown={(e) => searchValueClicked(e, item)} style={{ padding: '8px', cursor: 'pointer' }}>
                                        {item.name}
                                    </div>
                                ))}
                            </li>
                        )}
                    </ul>
                </details>
                )}

                {/* <button className="btn btn-ghost btn-circle">
                    <div className="indicator">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                        </svg>
                        <span className="badge badge-xs badge-primary indicator-item"></span>
                    </div>
                </button> */}

                <div>
                    <label className="switch" htmlFor="switch">
                        <input id="switch" type="checkbox" className="circle" checked={currentTheme === "light"}
                            onChange={toggleTheme} />
                        <svg
                            viewBox="0 0 384 512"
                            xmlns="http://www.w3.org/2000/svg"
                            className="moon svg"
                        ><path
                            d="M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"
                        ></path>
                        </svg>
                        <div className="sun svg">
                            <span className="dot"></span>
                        </div>
                    </label>
                </div>

                <div className="dropdown dropdown-end">
                    <div tabIndex={0} role="button">
                        <div className="avatar">
                            <div className="ring-primary ring-offset-base-100 w-14 rounded-full ring ring-offset-2">
                                {currentTheme === "light" ? (
                                    <img src={LoretteLogo} className='scale-100' />
                                ) : (
                                    <img src={LoretteLogoWhite} className='scale-100' />
                                )
                                }
                            </div>
                        </div>
                    </div>
                    <ul tabIndex={0} className="dropdown-content menu bg-[var(--gradientSecond)] rounded-box w-52 p-2 shadow border z-[9999]">
                        <li><a onClick={logout}>Logout</a></li>
                    </ul>
                </div>


            </div>
        </div>
    )
}

export default TopBar